/*jshint esversion: 6 */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const ResourcesGrid = (function($) {

  const _s = {
    container: '.wp-block-indp-resources-grid'
  };

  const _init = function() {
    if ($(_s.container).length === 0) {
      return;
    }

    _handleSwiper();
  };

  // ===================
  // Initialize Swiper
  const _handleSwiper = function() {
    const grids = document.querySelectorAll(_s.container);
    
    grids.forEach((grid) => {
      const swiperEl = grid.querySelector('.swiper');
      if (!swiperEl) {
        return;
      }
      
      const prevButton = grid.querySelector('.wp-block-indp-resources-grid__nav-prev');
      const nextButton = grid.querySelector('.wp-block-indp-resources-grid__nav-next');
      
      new Swiper(swiperEl, {
        modules: [Navigation],
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },
        breakpoints: {
          480: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2.2,
            spaceBetween: 25,
          },
          782: {
            slidesPerView: 2,
            spaceBetween: 25,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 25,
          }
        }
      });
    });
  };

  return {
    container: _s.container,
    init: _init
  };

})(jQuery);

export default ResourcesGrid;
